import React, { useState } from "react"
import { useForm } from "react-hook-form"
 

function ContactForm({ post }) {
  const [response, setResponse] = useState("")
  // const [complete, setComplete] = useState(false)
  const [loading, setLoading] = useState(false)
  const {
    register,
    handleSubmit, 
    reset,
    // formState: { errors },
  } = useForm()
  const onSubmit = data => {
    if (loading === true) return 

    setLoading(true)

    const postDetails = {
      baseUrl: `${process.env.GATSBY_GRAVITY_FORMS}/wp-json/gf/v2/forms/1`,
      formid: 1,
      payload: data,
    }

    fetch(`${process.env.GATSBY_LAMBDA_GF_ENDPOINT}`, {
      method: "post",
      body: JSON.stringify(postDetails),
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) { 
        if (data.status === "success") {
            setResponse(data.confirmation_message)
            setLoading(false)
          reset()
        } else {
        }
      })
      .catch(function (error) {
        console.error(error)
        setLoading(false)
        setResponse(data.message)
      })
  }

  return (
    <div className={"w-full mb-8"}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="divide-y divide-gray-200">
          <div className="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7 ">
            <div className="relative pb-4">
              <input
                {...register("input_1", { required: true })}
                type="text"
                className="peer placeholder-transparent dark:text-white dark:bg-gray-900 h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600"
                placeholder="Your Name"
              />
              <label
                htmlFor="input_1"
                className="absolute left-0 -top-3.5 text-gray-600 dark:text-white text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
              >
                Your Name
              </label>
            </div>
            <div className="relative pb-4">
              <input
                {...register("input_2", { required: true })}
                type="email"
                className="peer placeholder-transparent dark:text-white dark:bg-gray-900 h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600"
                placeholder="Your Email Address"
              />
              <label
                htmlFor="input_2"
                className="absolute left-0 -top-3.5 text-gray-600 dark:text-white text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
              >
                Your Email Address
              </label>
              <p className="mt-2 text-sm text-gray-400">
                Your email address will not be published or shared.
              </p>
            </div>
            <div className="relative pb-4">
              <textarea
                {...register("input_3", { required: true })}
                type="text"
                className="peer placeholder-transparent h-40 dark:text-white dark:bg-gray-900 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600"
                placeholder="Let us know what you tink"
              />
              <label
                htmlFor="input_3"
                className="absolute left-0 -top-3.5 dark:text-white dark:bg-gray-900 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
              >
                Your Comment
              </label>
            </div>
            <div className="relative flex items-center">
              <button className="bg-purple-900 text-white rounded-md px-4 py-2">
                {loading === true ? "Loading..." : "Submit"}
              </button>
              {response && (
                <div
                  className={"pl-4 text-gray-900 dark:text-white"}
                  dangerouslySetInnerHTML={{
                    __html: response,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default ContactForm
